import { render } from "./GoogleCarousel.vue?vue&type=template&id=4b77bce0&scoped=true"
import script from "./GoogleCarousel.vue?vue&type=script&lang=js"
export * from "./GoogleCarousel.vue?vue&type=script&lang=js"

import "./GoogleCarousel.vue?vue&type=style&index=0&id=4b77bce0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b77bce0"]])

export default __exports__